import { UserExperiments } from "../helpers/const";
import { RootState } from "./store";

/**
 * Получение гарантированного applicationId
 * Использовать только в тех местах, где точно уверены, что applicationId есть (по факту все страницы кроме регистрации/авторизации)
 */
export const selectApplicationId = (state: RootState) => {
  if (!state.newFormReducer.applicationId) {
    console.warn(
      "Не найден applicationId в селекторе selectApplicationId. Если вы увидели это сообщение - найдите место, где вызывается этот селектор и поменяйте его на selectNullableApplicationId",
      new Error().stack
    );
  }
  return state.newFormReducer.applicationId!;
};

/**
 * Получение applicationId, который может быть null
 * Использовать только в тех местах, где applicationId может отсутствовать (например, на экране регистрации/авторизации)
 */
export const selectNullableApplicationId = (state: RootState) =>
  state.newFormReducer.applicationId;

export const selectContactId = (state: RootState) =>
  state.authReducer.contactId;
export const selectPassportData = (state: RootState) =>
  state.passportReducer.passportData;
export const selectUserPhone = (state: RootState) => state.authReducer.phone;
export const selectGenders = (state: RootState) =>
  state.newFormReducer.dictionaries?.gender;
export const selectDictionaries = (state: RootState) =>
  state.newFormReducer.dictionaries;

/**
 * Клиент не проходил полностью анкету ранее
 */
export const selectIsFirstApplication = (state: RootState) =>
  state.authReducer.isFirstApplication;

/**
 * Клиент перешедший от партнера
 */
export const selectIsShortForm = (state: RootState) =>
  state.authReducer.isShortForm;

/**
 * Клиент не зарегитрирован и не автиоризован. Шлем с этим идентификатором его события смены страниц
 */
export const selectAnonymousId = (state: RootState) =>
  state.authReducer.anonymousId;

/**
 * У клиента нет успешно завершенных займов (это не isFirstApplication)
 */
export const selectIsNewClient = (state: RootState) =>
  state.authReducer.isNewClient ?? true;
export const selectSigningAgreementByAgreeTypeId =
  (agreeTypeId?: string) => (state: RootState) =>
    agreeTypeId ? state.agreementsReducer.signing[agreeTypeId] : null;

export const selectSigningAgrees = (state: RootState) =>
  state.agreementsReducer.signing;

export const selectFinancialAgreementOpened = (state: RootState) =>
  state.financialAgreementReducer.opened;
export const selectFinancialAgreementShowDocument = (state: RootState) =>
  state.financialAgreementReducer.showDocument;
export const selectFinancialAgreementDocumentText = (state: RootState) =>
  state.financialAgreementReducer.documentText;
export const selectVasBlockOpened = (id: string) => (state: RootState) =>
  state.vasBlockReducer[id]?.opened;
export const selectVasBlockShowAgree = (id: string) => (state: RootState) =>
  state.vasBlockReducer[id]?.showAgree;
export const selectLastStep = (state: RootState) => state.stepsReducer.lastStep;
export const selectIsAuth = (state: RootState) => state.authReducer.isAuth;
export const selectIsOperator = (state: RootState) =>
  state.authReducer.isOperator;
export const selectDisplayName = (state: RootState) =>
  state.authReducer.displayName;
export const selectRegistrationAgrees = (state: RootState) =>
  state.agreementsReducer.registration;
export const selectRegistrationDocumentRuleId = (state: RootState) =>
  state.registrationDocumentsReducer.documentRuleId;

export const selectReapplicationAgrees = (state: RootState) =>
  state.agreementsReducer.reapplicationConfirmation;

export const selectServerSettings = (state: RootState) =>
  state.serverSettingsReducer;

export const selectExperimentInsuranceDisabling = (state: RootState) =>
  state.experimentReducer.insuranceDisabling;
export const selectLockOAuthData = (state: RootState) =>
  state.oauthReducer.lockEsiaData || state.oauthReducer.lockTinkoffData;
export const selectLockEsiaData = (state: RootState) =>
  state.oauthReducer.lockEsiaData;
export const selectLockTinkoffData = (state: RootState) =>
  state.oauthReducer.lockTinkoffData;

export const selectExperimentGroup =
  (groupId: (typeof UserExperiments)[keyof typeof UserExperiments]) =>
  (state: RootState) =>
    state.userExperimentsReducer.groups?.[groupId];

export const selectLoan = (state: RootState) => state.loanReducer;
export const selectLoanLoading = (state: RootState) =>
  selectLoan(state).loading;

export const selectLoaders = (state: RootState) => state.loadersReducer.loaders;
export const selectLoadersLoading = (state: RootState) =>
  state.loadersReducer.loading;

export const selectLoadersByFormId =
  (loaderFormId: string) => (state: RootState) =>
    state.loadersReducer.loaders.filter(
      (loader) =>
        loader.loaderFormId.toLowerCase() === loaderFormId.toLowerCase()
    );
